import { useQuery } from "@tanstack/react-query";
import { RestEndpoints } from "../../../api/endpoints";
import { ReactQueryConfig } from "../../../config/react-query-config";
import getInstance from "../../../utils/rest";
import { GroupConverter } from "../../../domain/converter/group.converter";
import { IGroupOrManufacturerList } from "../../../domain/group/group-lean";
import { IPaginationMeta } from "../../../domain/pagination/pagination-meta";
import { IGroupLeanListModel } from "../../../models/group/group-lean.model";
import { IGetGroupsLeanFilter } from "../../models/group/get-group.model";
import { SharedQueryKeys } from "../query-keys";

const getGroupsLeanWithFilters = async (
  paginationStatus: IPaginationMeta,
  filter: IGetGroupsLeanFilter,
): Promise<IGroupOrManufacturerList> => {
  const { groupType, nameQuery, erpQuery } = filter;
  const { page, pageSize } = paginationStatus;
  const { data } = await getInstance().get<IGroupLeanListModel>(RestEndpoints.GroupsLean, {
    params: { groupType, nameQuery, erpQuery, page, pageSize },
  });
  return GroupConverter.groupOrManufacturerListToDomain(data);
};

export const useGetGroupsLeanFiltersQuery = (
  paginationStatus: IPaginationMeta,
  filter: IGetGroupsLeanFilter,
) => {
  const { page, pageSize } = paginationStatus;
  return useQuery({
    queryKey: [SharedQueryKeys.GetGroupsLeanWithFilters, { page, pageSize }, filter],
    queryFn: () => getGroupsLeanWithFilters(paginationStatus, filter),
    staleTime: ReactQueryConfig.staleTime,
  });
};
